import { Segment, Text } from "@simplybusiness/mobius";

export type JourneyContinuationNoticeProps = {
  /** The product name that will be quoted after checkout */
  continuationProduct: string;
};

export const JourneyContinuationNotice = ({
  continuationProduct,
}: JourneyContinuationNoticeProps) => {
  return (
    <Segment
      className="mobius-journey-continuation-notice"
      data-testid="journey-continuation-notice"
    >
      <Text
        elementType="h4"
        className="mobius-journey-continuation-notice__heading"
      >
        We did not forget about {continuationProduct}
      </Text>
      <Text
        elementType="span"
        className="mobius-journey-continuation-notice__body"
      >
        We will get your {continuationProduct} quote right after you checkout.
      </Text>
    </Segment>
  );
};

JourneyContinuationNotice.displayName = "JourneyContinuationNotice";
